import { graphql } from 'gatsby';
import React, { useContext , useEffect} from "react"

import { renderSections } from '../helpers/renderer';
import Film from '../components/film'
import Layout from '../components/layout'
import queryString from 'query-string'

import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/GlobalContextProvider"

const HomePage = props => {


  let params = queryString.parse(props.location.search)

  const dispatch = useContext(GlobalDispatchContext)
  const state = useContext(GlobalStateContext)


  useEffect(() => {
    if ( params.utm_source ){
      dispatch({ type: "SET_UTM_SOURCE", payload:params.utm_source })
    }
    if ( params.utm_campaign ){
      dispatch({ type: "SET_UTM_CAMPAIGN", payload:params.utm_campaign })
    }
    if ( params.utm_medium ){
      dispatch({ type: "SET_UTM_MEDIUM", payload:params.utm_medium })
    }
  }, [dispatch, params])


  const {
    body: [{
      items: slides,
      primary: {
        youtube,
        youku,
        video_mp4: mp4,
        video_ogg: ogg,
        video_webm: webm,
        play_film_text: { text: playFilmText },
      }
    }],
    body_copy: { html: filmTagLine },
    alt_hero_logo: altHeroLogo,
    body: sections
  } = props.data.prismicHomePage.data

  let lang;
  if(props.data.prismicHomePage.uid === 'home-ch'){
    lang = 'ch';
  } else if (props.data.prismicHomePage.uid === 'home-jp') {
    lang = 'jp';
  } else {
    lang = 'en';
  }

  return (
    <Layout lang={lang} alt_hero_logo={altHeroLogo.url}  utm_campaign={state.utm_campaign} utm_source={state.utm_source} utm_medium={state.utm_medium}>
      <Film
        delay={1500}
        video={{
          youtube,
          youku,
          mp4: mp4 && mp4.url,
          ogg: ogg && ogg.url,
          webm: webm && webm.url,
          playFilmText,
          filmTagLine
        }}
        slides={slides.map(
          ({ link, image, title, caption, focal_point: focalPoint }) => ({
            link,
            image: image.url,
            title: title.html,
            caption: caption.html,
            focalPoint
          })
        )}
      />
      {renderSections(sections)}
    </Layout>
  )
}

export default HomePage



export const pageQuery = graphql`
  query ($id:String) {
    prismicHomePage(id: {eq: $id}) {
      uid
      id
      data {
        page_title {
          text
        }
        body_copy {
          html
        }
        body {
          ... on PrismicHomePageBodyFilmCarousel {
            ...HomePageFilmCarousel
          }
        }
        alt_hero_logo {
          url
        }
      }
    }
  }
`
